import classNames from 'clsx';
import React, { type FC, type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { HintPosition } from 'reactApp/ui/Hint/Hint.constants';
import styles from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/SingleSpaceProgress.css';
import type { ISpaceLabel } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/SingleSpaceProgress.types';
import { noopVoid } from 'reactApp/utils/helpers';

export const SpaceLabel: FC<ISpaceLabel & { clickable: boolean }> = ({
    text,
    id,
    hintText,
    isOverquota,
    clickable,
    onClick = noopVoid,
    rebranding = false,
}): ReactElement => {
    const inlineStyles =
        isDarkTheme && rebranding && id === 'cloud'
            ? { background: 'var(--rebranding_dark_theme_color_lime)' }
            : rebranding && id === 'cloud'
            ? { background: 'var(--rebranding_color_lime)' }
            : {};
    return (
        <div className={styles.infoBlock}>
            <Hint text={hintText} positionStrategy={HintPosition.relativeToCursor}>
                <div
                    className={classNames(styles.info, {
                        [styles.info_clickable]: clickable,
                    })}
                    onClick={onClick}
                >
                    <div
                        className={classNames(styles.infoLine, styles[`line_${id}`], {
                            [styles.lineFilled_overquota]: isOverquota,
                        })}
                        style={inlineStyles}
                    />
                    <div className={styles.label}>{text}</div>
                </div>
            </Hint>
        </div>
    );
};
